var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "54px",
    viewBox: "0 0 56 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8482EE28-BEC2-428D-A36B-0833012DBCFF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.69402105,24.5 L6.45717902,50.75 L49.155348,50.75 L51.918506,24.5 L3.69402105,24.5 Z M53.8623843,21 C54.8288826,21 55.6123843,21.7835017 55.6123843,22.75 C55.6123843,22.8111922 55.6091748,22.8723424 55.6027689,22.9331984 L52.6361164,51.1163967 C52.4486097,52.8977103 50.9465024,54.25 49.1553472,54.25 L6.45717899,54.25 C4.66602388,54.25 3.16391656,52.8977103 2.97640987,51.1163967 L0.00975737702,22.9331984 C-0.0914202916,21.9720105 0.605755712,21.1107931 1.56694356,21.0096155 C1.62779958,21.0032096 1.6889497,21 1.75014194,21 L53.8623843,21 Z M20.8062635,1.75 C22.7392602,1.75 24.3062636,3.31700338 24.3062636,5.25 L24.3062636,8.75 L48.8062642,8.75 C50.7392609,8.75 52.3062643,10.3170034 52.3062643,12.25 L52.3062643,17.5 L48.8062642,17.5 L48.8062642,12.25 L20.8062635,12.25 L20.8062635,5.25 L7.01132244,5.25 L7.01132244,17.5 L3.51132244,17.5 L3.51132244,5.25 C3.51132244,3.31700338 5.07832586,1.75 7.01132244,1.75 L20.8062635,1.75 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "6_Automated-Execution",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upload-Step-2-V2",
    transform: "translate(-952.000000, -373.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Folder-Icon-\\xA9\\uFE0F-Logos-and-Icons/Icon/Outline/Folder-Open",
    transform: "translate(952.000000, 372.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Folder-Open",
    fill: "#333333",
    xlinkHref: "#path-1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.21a1e6bc8967c7175ec7a538db893858.svg";
export { ForwardRef as ReactComponent };